<div class="new-filter" [ngClass]="{ 'new-filter--chosen': isValue }">
  <div class="new-filter__label">
    <div class="new-filter__label__text">
      {{ name }}
    </div>
  </div>
  <ng-container *ngTemplateOutlet="template"></ng-container>
</div>
